import Swiper, { Autoplay, Controller, Navigation, Pagination, Parallax } from 'swiper'
import { debounce, throttle } from 'throttle-debounce'
import { theme } from '../utility'
import { breakpoint } from '../utility/helpers'

Swiper.use([Autoplay, Controller, Navigation, Pagination, Parallax])

const swiperClassNames = {
  containerModifierClass: 'hero--',
  noSwipingClass: 'hero--no-swiping',
  slideClass: 'hero__slide',
  slideActiveClass: 'hero__slide--active',
  slideNextClass: 'hero__slide--next',
  slidePrevClass: 'hero__slide--prev',
  slideVisibleClass: 'hero__slide--visible',
  wrapperClass: 'hero__wrapper',
}

export const hero = (target) => {
  const el = {
    hero: target,
    textSlider: target.querySelector('.hero__slides--text .hero__container'),
    imageSlider: target.querySelector('.hero__slides--images .hero__container'),
    backgroundSlider: target.querySelector('.hero__slides--background .hero__container'),
    slideBackgrounds: target.querySelectorAll('.hero__background'),
    header: document.querySelector<HTMLElement>('.header'),
  }

  let imageSlider = null
  let textSlider = null
  let backgroundSlider = null

  const method = {
    init: () => {
      method.initSwipers()
      theme.setHeroBackgroundsAndColors(target)

      backgroundSlider.controller.control = imageSlider
      imageSlider.controller.control = textSlider

      window.addEventListener('resize', debounce(120, method.rerender))

      window.addEventListener('resize', debounce(120, method.pauseAutoplayOnMobile))
      window.addEventListener('scroll', throttle(60, method.pauseAutoplayOnMobile))
    },

    rerender: () => {
      if (backgroundSlider) backgroundSlider.update()
      if (imageSlider) imageSlider.update()
      if (textSlider) textSlider.update()
    },

    initSwipers: () => {
      const isSwiperDisabled = el.backgroundSlider.querySelectorAll('.hero__slide').length <= 1

      backgroundSlider = new Swiper(el.backgroundSlider, {
        allowTouchMove: !isSwiperDisabled,
        autoplay: isSwiperDisabled
          ? false
          : {
              delay: 3456,
              disableOnInteraction: true,
            },
        grabCursor: !isSwiperDisabled,
        loop: !isSwiperDisabled,
        navigation: {
          nextEl: '.hero__button--next',
          prevEl: '.hero__button--previous',
        },
        on: {
          afterInit: () => {
            setTimeout(method.updateHeaderTheme, 1)
          },
          slideChangeTransitionStart: method.updateHeaderTheme,
        },
        pagination: {
          bulletActiveClass: 'hero__pagination-bullet--active',
          bulletClass: 'hero__pagination-bullet',
          bulletElement: 'button',
          clickable: true,
          el: '.hero__pagination',
          renderBullet: (index, className) =>
            `<button aria-label="Mynd ${index + 1}" class="hero__pagination-bullet ${className}"></button>`,
          type: 'bullets',
        },
        speed: 1234,
        parallax: true,
        ...swiperClassNames,
      })

      textSlider = new Swiper(el.textSlider, {
        allowTouchMove: false,
        autoHeight: true,
        loop: !isSwiperDisabled,
        spaceBetween: 40,
        speed: 1234,
        parallax: true,
        ...swiperClassNames,
      })

      imageSlider = new Swiper(el.imageSlider, {
        allowTouchMove: false,
        loop: !isSwiperDisabled,
        speed: 1234,
        parallax: true,
        ...swiperClassNames,
      })
    },

    pauseAutoplayOnMobile: () => {
      const isDesktop = window.innerWidth >= breakpoint.desktop.xs
      const isScrolledDown = window.scrollY > target.offsetHeight

      if (!isDesktop && backgroundSlider.autoplay.running && isScrolledDown) {
        backgroundSlider.autoplay.stop()
      }
    },

    updateHeaderTheme: () => {
      const activeBackgroundSlide = target.querySelector('.hero__slide--background.hero__slide--active')
      const currentTheme = activeBackgroundSlide.dataset.theme

      theme.el.header.dataset.theme = currentTheme
    },
  }

  method.init()
}
